export default "<template>\n    <slot name=\"tab-content\"></slot>\n</template>";